import { HOME_PAGE_MAX_SOW_SECTION } from "../../../../../../applications/constants/AppConst";
import { ItemModel } from "../../../../../../infrastructure/model/ProductItemModel";
import "../../styles/HomPageSection.scss";
import ViewAllButton from "./ViewAllButton";

interface HomeSectionProps {
  sectionKey: string;
  title: string;
  icon: any;
  items: ItemModel[];
  onAdd: (item: ItemModel) => void;
  className?: string;
  variant?: "default" | "flash" | "best";
  onShowAll?: (val: string) => void;
}

function HomePageSection(props: HomeSectionProps) {
  const { sectionKey, title, items, onAdd, icon, className, variant, onShowAll } = props;

  return (
    <section className={`home-page-section ${className ?? ""}`}>
      <div className="section-header">
        <h2>
          <span className="section-icon">{icon}</span>
          {title}
        </h2>
        {variant === "best" && <span className="best-tag">TOP BÁN CHẠY</span>}
      </div>
      {variant === "best" && (
        <p className="best-subtitle">Những sản phẩm được khách hàng lựa chọn nhiều nhất</p>
      )}
      <div className="section-content">
        <div className="products-grid">
          {items.slice(0, HOME_PAGE_MAX_SOW_SECTION).map((item) => (
            <div key={item.id} className="product-card">
              <div className="image-wrapper">
                <img src={item.image} alt={item.name} />
                <button className="add-btn" onClick={() => onAdd(item)}>
                  +
                </button>
              </div>

              <div className="product-info">
                <span className="brand">TOPUTII COFFEE</span>
                <h4>{item.name}</h4>
                <span className="price">{item?.size_mapping?.[0]?.price?.toLocaleString()}đ</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {items.length > HOME_PAGE_MAX_SOW_SECTION && (
        <ViewAllButton
          onClick={() => onShowAll?.(sectionKey)}
          highlight="normal" // hoặc "best" | "normal"
        />
      )}
    </section>
  );
}

export default HomePageSection;
